import { lazy } from 'react';
import MainLayout from 'layouts/MainLayout';

const DashboardPage = lazy(() => import('pages/Ufficio/Dashboard'));

//MAGAZZINO
const MagazzinoPage = lazy(() => import('pages/Ufficio/Magazzino/Magazzino'));

// LOTTI
const LottiPage = lazy(() => import('pages/Ufficio/Lotti/Lotti'));
const LottoPage = lazy(() => import('pages/Ufficio/Lotti/Lotto'));
const LottoPrintPage = lazy(() => import('pages/Ufficio/Lotti/LottoPrint'));
import LottoHistoryPage from 'pages/Ufficio/Lotti/LottoHistory';
import LottoFuturePage from 'pages/Ufficio/Lotti/LottoFuture';
// LAVORAZIONI
const LavorazioniPage = lazy(() => import('pages/Ufficio/Lavorazioni/Lavorazioni'));
const LavorazionePage = lazy(() => import('pages/Ufficio/Lavorazioni/Lavorazione'));
const LavorazioneEditPage = lazy(() => import('pages/Ufficio/Lavorazioni/Modifica'));
const SpostamentiPage = lazy(() => import('pages/Ufficio/Spostamenti/Spostamenti'));

// INGRESSI
const IngressiPage = lazy(() => import('pages/Ufficio/Ingressi/Ingressi'));
const IngressoPage = lazy(() => import('pages/Ufficio/Ingressi/Ingresso'));
const CreaIngressoPage = lazy(() => import('pages/Ufficio/Ingressi/Crea'));
const ModificaIngressoPage = lazy(() => import('pages/Ufficio/Ingressi/Modifica'));
// USCITE
const UscitePage = lazy(() => import('pages/Ufficio/Uscite/Uscite'));
const UscitaPage = lazy(() => import('pages/Ufficio/Uscite/Uscita'));
const UscitaPrintPage = lazy(() => import('pages/Ufficio/Uscite/UscitaPrint'));
const CreaUscitaPage = lazy(() => import('pages/Ufficio/Uscite/Crea'));
const ModificaUscitaPage = lazy(() => import('pages/Ufficio/Uscite/Modifica'));
// IMPOSTAZIONI
const ImpostazioniPage = lazy(() => import('pages/Ufficio/Impostazioni/Impostazioni'));
// PRODOTTI
const ProdottiPage = lazy(() => import('pages/Ufficio/Impostazioni/Prodotti/Prodotti'));
const ProdottoPage = lazy(() => import('pages/Ufficio/Impostazioni/Prodotti/Prodotto'));
const CreaProdottoPage = lazy(() => import('pages/Ufficio/Impostazioni/Prodotti/Crea'));
const ModificaProdottoPage = lazy(() => import('pages/Ufficio/Impostazioni/Prodotti/Modifica'));
// CLIENTI
const ClientiPage = lazy(() => import('pages/Ufficio/Impostazioni/Clienti/Clienti'));
const ClientePage = lazy(() => import('pages/Ufficio/Impostazioni/Clienti/Cliente'));
const CreaClientePage = lazy(() => import('pages/Ufficio/Impostazioni/Clienti/Crea'));
const ModificaClientePage = lazy(() => import('pages/Ufficio/Impostazioni/Clienti/Modifica'));
// FATTURAZIONE
const FatturazionePage = lazy(() => import('pages/Ufficio/Impostazioni/Fatturazione/Fatturazione'));
const ModificaFatturazionePage = lazy(() => import('pages/Ufficio/Impostazioni/Fatturazione/Modifica'));
// SPEDIZIONE
const SpedizionePage = lazy(() => import('pages/Ufficio/Impostazioni/Spedizione/Spedizione'));
const ModificaSpedizionePage = lazy(() => import('pages/Ufficio/Impostazioni/Spedizione/Modifica'));
// FORNITORI
const FornitoriPage = lazy(() => import('pages/Ufficio/Impostazioni/Fornitori/Fornitori'));
const FornitorePage = lazy(() => import('pages/Ufficio/Impostazioni/Fornitori/Fornitore'));
const CreaFornitorePage = lazy(() => import('pages/Ufficio/Impostazioni/Fornitori/Crea'));
const ModificaFornitorePage = lazy(() => import('pages/Ufficio/Impostazioni/Fornitori/Modifica'));
// TRASPORTATORI
const TrasportatoriPage = lazy(() => import('pages/Ufficio/Impostazioni/Trasportatori/Trasportatori'));
const TrasportatorePage = lazy(() => import('pages/Ufficio/Impostazioni/Trasportatori/Trasportatore'));
const CreaTrasportatorePage = lazy(() => import('pages/Ufficio/Impostazioni/Trasportatori/Crea'));
const ModificaTrasportatorePage = lazy(() => import('pages/Ufficio/Impostazioni/Trasportatori/Modifica'));
// TIPOLOGIE LAVORAZIONI
const LavorazioniTypePage = lazy(() => import('pages/Ufficio/Impostazioni/Lavorazioni/Lavorazioni'));
const LavorazioneTypePage = lazy(() => import('pages/Ufficio/Impostazioni/Lavorazioni/Lavorazione'));
const CreaLavorazioneTypePage = lazy(() => import('pages/Ufficio/Impostazioni/Lavorazioni/Crea'));
const ModificaLavorazioneTypePage = lazy(() => import('pages/Ufficio/Impostazioni/Lavorazioni/Modifica'));
// CATEGORIE
const CategoriePage = lazy(() => import('pages/Ufficio/Impostazioni/Categorie/Categorie'));
const CategoriaPage = lazy(() => import('pages/Ufficio/Impostazioni/Categorie/Categoria'));
const CreaCategoriaPage = lazy(() => import('pages/Ufficio/Impostazioni/Categorie/Crea'));
const ModificaCategoriaPage = lazy(() => import('pages/Ufficio/Impostazioni/Categorie/Modifica'));
// LOCATIONS
const LocationsPage = lazy(() => import('pages/Ufficio/Impostazioni/Locations/Locations'));
const LocationPage = lazy(() => import('pages/Ufficio/Impostazioni/Locations/Location'));
const CreaLocationPage = lazy(() => import('pages/Ufficio/Impostazioni/Locations/Crea'));
const ModificaLocationPage = lazy(() => import('pages/Ufficio/Impostazioni/Locations/Modifica'));
// CONTENITORI
const ContenitoriPage = lazy(() => import('pages/Ufficio/Impostazioni/Contenitori/Contenitori'));
const ContenitorePage = lazy(() => import('pages/Ufficio/Impostazioni/Contenitori/Contenitore'));
const CreaContenitorePage = lazy(() => import('pages/Ufficio/Impostazioni/Contenitori/Crea'));
const ModificaContenitorePage = lazy(() => import('pages/Ufficio/Impostazioni/Contenitori/Modifica'));
// UTENTI
import UtentiPage from 'pages/Ufficio/Impostazioni/Utenti/Utenti';
import UtentePage from 'pages/Ufficio/Impostazioni/Utenti/Utente';
import CreaUtentePage from 'pages/Ufficio/Impostazioni/Utenti/Crea';
import ModificaUtentePage from 'pages/Ufficio/Impostazioni/Utenti/Modifica';

const routes = [{
    layout: MainLayout,
    routes: [{
        path: '/',
        element: DashboardPage,
        exact: true,
        analytics: { name: ["Dashboard"] },
    }, {
        // LOTTI

        path: '/lotti',
        element: LottiPage,
        exact: true,
        analytics: { name: ["Lotti"] },
    }, {
        path: '/lotti/:lottoId',
        element: LottoPage,
        exact: true,
        analytics: { name: ["Lotto"] },
    }, {
        path: '/lotti/:lottoId/stampa',
        element: LottoPrintPage,
        exact: true,
        analytics: { name: ["Lotto", "Stampa"] },
    }, {
        path: '/lotti/:lottoId/history',
        element: LottoHistoryPage,
        exact: true,
        analytics: { name: ["Lotto", "Storico"] },
    }, {
        path: '/lotti/:lottoId/future',
        element: LottoFuturePage,
        exact: true,
        analytics: { name: ["Lotto", "Futuro"] },
    }, {
        // MAGAZZINO

        path: '/magazzino',
        element: MagazzinoPage,
        exact: true,
        analytics: { name: ["Magazzino"] },
    }, {
        // LAVORAZIONI

        path: '/lavorazioni',
        element: LavorazioniPage,
        exact: true,
        analytics: { name: ["Lavorazioni"] },
    }, {
        path: '/lavorazioni/:lavorazioneId',
        element: LavorazionePage,
        exact: true,
        analytics: { name: ["Lavorazione"] },
    }, {
        path: '/lavorazioni/:lavorazioneId/modifica',
        element: LavorazioneEditPage,
        exact: true,
        analytics: { name: ["Lavorazione", "Modifica"] },
    }, {
        // LAVORAZIONI

        path: '/spostamenti',
        element: SpostamentiPage,
        exact: true,
        analytics: { name: ["Spostamenti"] },
    }, {
        // INGRESSI

        path: '/ingressi',
        element: IngressiPage,
        exact: true,
        analytics: { name: ["Ingressi"] },
    }, {
        path: '/ingressi/crea',
        element: CreaIngressoPage,
        exact: true,
        analytics: { name: ["Crea ingresso"] },
    }, {
        path: '/ingressi/:ingressoId',
        element: IngressoPage,
        exact: true,
        analytics: { name: ["Ingresso"] },
    }, {
        path: '/ingressi/:ingressoId/modifica',
        element: ModificaIngressoPage,
        exact: true,
        analytics: { name: ["Ingresso", "Modifica"] },
    }, {
        // USCITE

        path: '/uscite',
        element: UscitePage,
        exact: true,
        analytics: { name: ["Uscite"] },
    }, {
        path: '/uscite/crea',
        element: CreaUscitaPage,
        exact: true,
        analytics: { name: ["Crea uscita"] },
    }, {
        path: '/uscite/:uscitaId/stampa',
        element: UscitaPrintPage,
        exact: true,
        analytics: { name: ["Uscita", "Stampa"] },
    }, {
        path: '/uscite/:uscitaId',
        element: UscitaPage,
        exact: true,
        analytics: { name: ["Uscita"] },
    }, {
        path: '/uscite/:uscitaId/modifica',
        element: ModificaUscitaPage,
        exact: true,
        analytics: { name: ["Uscita", "Modifica"] },
    }, {
        // IMPOSTAZIONI

        path: '/impostazioni',
        element: ImpostazioniPage,
        exact: true,
        analytics: { name: ["Impostazioni"] },
    }, {
        // CLIENTI

        path: '/impostazioni/clienti',
        element: ClientiPage,
        exact: true,
        analytics: { name: ["Clienti"] },
    }, {
        path: '/impostazioni/clienti/crea',
        element: CreaClientePage,
        exact: true,
        analytics: { name: ["Crea cliente"] },
    }, {
        path: '/impostazioni/clienti/:clienteId',
        element: ClientePage,
        exact: true,
        analytics: { name: ["Cliente"] },
    }, {
        path: '/impostazioni/clienti/:clienteId/modifica',
        element: ModificaClientePage,
        exact: true,
        analytics: { name: ["Cliente", "Modifica"] },
    }, {
        // FORNITORI

        path: '/impostazioni/fornitori',
        element: FornitoriPage,
        exact: true,
        analytics: { name: ["Fornitori"] },
    }, {
        path: '/impostazioni/fornitori/crea',
        element: CreaFornitorePage,
        exact: true,
        analytics: { name: ["Fornitori"] },
    }, {
        path: '/impostazioni/fornitori/:fornitoreId',
        element: FornitorePage,
        exact: true,
        analytics: { name: ["Fornitore"] },
    }, {
        path: '/impostazioni/fornitori/:fornitoreId/modifica',
        element: ModificaFornitorePage,
        exact: true,
        analytics: { name: ["Fornitore", "Modifica"] },
    }, {
        // FATTURAZIONE
        path: '/impostazioni/fatturazione',
        element: FatturazionePage,
        exact: true,
        analytics: { name: ["Fatturazione"] },
    }, {
        path: '/impostazioni/fatturazione/modifica',
        element: ModificaFatturazionePage,
        exact: true,
        analytics: { name: ["Fatturazione", "Modifica"] },
    }, {
        // SPEDIZIONE
        path: '/impostazioni/spedizione',
        element: SpedizionePage,
        exact: true,
        analytics: { name: ["Spedizione"] },
    }, {
        path: '/impostazioni/spedizione/modifica',
        element: ModificaSpedizionePage,
        exact: true,
        analytics: { name: ["Spedizione", "Modifica"] },
        // TRASPORTATORI
    }, {
        path: '/impostazioni/trasportatori',
        element: TrasportatoriPage,
        exact: true,
        analytics: { name: ["Trasportatori"] },
    }, {
        path: '/impostazioni/trasportatori/crea',
        element: CreaTrasportatorePage,
        exact: true,
        analytics: { name: ["Crea trasportatore"] },
    }, {
        path: '/impostazioni/trasportatori/:trasportatoreId',
        element: TrasportatorePage,
        exact: true,
        analytics: { name: ["Trasportatore"] },
    }, {
        path: '/impostazioni/trasportatori/:trasportatoreId/modifica',
        element: ModificaTrasportatorePage,
        exact: true,
        analytics: { name: ["Trasportatore", "Modifica"] },
    }, {
        // PRODOTTI

        path: '/impostazioni/prodotti',
        element: ProdottiPage,
        exact: true,
        analytics: { name: ["Prodotti"] },
    }, {
        path: '/impostazioni/prodotti/crea',
        element: CreaProdottoPage,
        exact: true,
        analytics: { name: ["Crea prodotto"] },
    }, {
        path: '/impostazioni/prodotti/:prodottoId',
        element: ProdottoPage,
        exact: true,
        analytics: { name: ["Prodotto"] },
    }, {
        path: '/impostazioni/prodotti/:prodottoId/modifica',
        element: ModificaProdottoPage,
        exact: true,
        analytics: { name: ["Prodotto", "Modifica"] },
    }, {
        // LAVORAZIONI

        path: '/impostazioni/lavorazioni',
        element: LavorazioniTypePage,
        exact: true,
        analytics: { name: ["Lavorazioni"] },
    }, {
        path: '/impostazioni/lavorazioni/crea',
        element: CreaLavorazioneTypePage,
        exact: true,
        analytics: { name: ["Crea Lavorazione"] },
    }, {
        path: '/impostazioni/lavorazioni/:lavorazioneId',
        element: LavorazioneTypePage,
        exact: true,
        analytics: { name: ["Lavorazione"] },
    }, {
        path: '/impostazioni/lavorazioni/:lavorazioneId/modifica',
        element: ModificaLavorazioneTypePage,
        exact: true,
        analytics: { name: ["Lavorazione", "Modifica"] },
    }, {
        // CATEGORIE

        path: '/impostazioni/categorie',
        element: CategoriePage,
        exact: true,
        analytics: { name: ["Categorie"] },
    }, {
        path: '/impostazioni/categorie/crea',
        element: CreaCategoriaPage,
        exact: true,
        analytics: { name: ["Crea categoria"] },
    }, {
        path: '/impostazioni/categorie/:categoriaId',
        element: CategoriaPage,
        exact: true,
        analytics: { name: ["Categoria"] },
    }, {
        path: '/impostazioni/categorie/:categoriaId/modifica',
        element: ModificaCategoriaPage,
        exact: true,
        analytics: { name: ["Categoria", "Modifica"] },
    }, {
        // LOCATIONS

        path: '/impostazioni/locations',
        element: LocationsPage,
        exact: true,
        analytics: { name: ["Locations"] },
    }, {
        path: '/impostazioni/locations/crea',
        element: CreaLocationPage,
        exact: true,
        analytics: { name: ["Crea location"] },
    }, {
        path: '/impostazioni/locations/:locationId',
        element: LocationPage,
        exact: true,
        analytics: { name: ["Location"] },
    }, {
        path: '/impostazioni/locations/:locationId/modifica',
        element: ModificaLocationPage,
        exact: true,
        analytics: { name: ["Location", "Modifica"] },
    }, {
        // CONTENITORI

        path: '/impostazioni/contenitori',
        element: ContenitoriPage,
        exact: true,
        analytics: { name: ["Contenitori"] },
    }, {
        path: '/impostazioni/contenitori/crea',
        element: CreaContenitorePage,
        exact: true,
        analytics: { name: ["Crea contenitore"] },
    }, {
        path: '/impostazioni/contenitori/:contenitoreId',
        element: ContenitorePage,
        exact: true,
        analytics: { name: ["Contenitore"] },
    }, {
        path: '/impostazioni/contenitori/:contenitoreId/modifica',
        element: ModificaContenitorePage,
        exact: true,
        analytics: { name: ["Contenitore", "Modifica"] },
    }, {
        // UTENTI
        path: '/impostazioni/utenti',
        element: UtentiPage,
        exact: true,
        analytics: { name: ["Utenti"] },
    }, {
        path: '/impostazioni/utenti/crea',
        element: CreaUtentePage,
        exact: true,
        analytics: { name: ["Crea utente"] },
    }, {
        path: '/impostazioni/utenti/:userId',
        element: UtentePage,
        exact: true,
        analytics: { name: ["Utente"] },
    }, {
        path: '/impostazioni/utenti/:userId/modifica',
        element: ModificaUtentePage,
        exact: true,
        analytics: { name: ["Utente", "Modifica"] },
    }]
}]

export default routes;